import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {faSignIn} from "@fortawesome/free-solid-svg-icons";
import {FormHandler} from "@iw-shared/form/models/form-handler";

@Component({
  selector: 'iw-shared-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {
  @Output() onValidationSuccess: EventEmitter<{ password: string }> = new EventEmitter<{ password: string }>();
  @Input() formHandler!: FormHandler;

  form: FormGroup = this.fb.group({
    password: ['', [
      Validators.required,
      Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')
    ]],
    passwordRetype: ['']
  });

  constructor(private fb: FormBuilder) {
  }

  ngOnInit(): void {
  }

  isFormKeyInvalid(key: string, displayIfSubmitForm: boolean = true): boolean {
    let form = this.form?.get(key);
    return !!(form?.invalid &&
      (
        this.formHandler.getFormStatus() == 'submitForm' &&
        displayIfSubmitForm
      )
    );
  }

  submit() {
    if (this.form.get('password')?.value != this.form.get('passwordRetype')?.value) {
      this.form.get('passwordRetype')?.setErrors({'passwordRetype': true});
      this.form.updateValueAndValidity();
    }
    if (this.form.invalid) {
      this.formHandler.setFormStatus({formStatus: 'submitForm'});
      return;
    }
    if (this.formHandler.getFormStatus() == 'loading') {
      return;
    }

    this.onValidationSuccess.emit({password: this.form.get('password')?.value ?? ''});
  }


  protected readonly faSignIn = faSignIn;
}
